import { memo, useCallback } from 'react';
import { useAsync } from 'react-use';
import Slider from 'react-slick';
import cn from 'classnames';
import { getWithUrl } from 'src/utils/http';
import { Container, Element, RouterLink } from 'src/components';
import MatchItem from './MatchItem';

import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/constants';
import { API_URL } from '@zmedia/bm-soccer-ui/constants/env';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';

interface ISoccerEvent {
    items: IMatch[];
}

const SOCCER_API = API_URL + '/match/get/list-top';

const EventSoccer = () => {
    const matchState = useAsync(() => getWithUrl(SOCCER_API));

    const data: ISoccerEvent = matchState.value?.data || {};
    const { items = [] } = data;

    const renderItem = useCallback(() => {
        return items.map((item: IMatch) => (
            <RouterLink
                key={item.id}
                to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
            >
                <MatchItem {...item} />
            </RouterLink>
        ));
    }, [items]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        variableWidth: true,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 4000,
        slidesToScroll: 2,
    };

    if (!items.length) {
        return null;
    }

    return (
            <Element className={cn('event-soccer', 'mt-[-15px] mb-[15px]')}>
                <Container>
                    <Element className={'max-md:mx-[-15px]'}>
                        <Slider {...settings}>{renderItem()}</Slider>
                    </Element>
                </Container>
            </Element>
    );
};
export default memo(EventSoccer);
